
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-week");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/week/index.js
// module id = BFZB
// module chunks = 11